import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'Massage Party',
    href: '#massage-party'
  }, {
    name: 'Staff',
    href: '#staff'
  }, {
    name: 'Facilities',
    href: '#facilities'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-plum-950/90 backdrop-blur-md py-4 border-b border-lavender-400/10' : 'bg-transparent py-6'}`} data-id="element-361">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-362">
        <a href="#" className="font-serif text-3xl tracking-widest text-lavender-50 hover:text-lavender-300 transition-colors" data-id="element-363">
          AFRIEL
        </a>

        <nav className="hidden md:flex items-center space-x-8" data-id="element-364">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm uppercase tracking-widest text-lavender-100/70 hover:text-lavender-300 transition-colors" data-id="element-365">
              {link.name}
            </a>)}
          <div className="flex flex-col items-center gap-2" data-id="element-366">
            <a href="#reservations" className="px-6 py-2 bg-gradient-to-r from-lavender-500 to-rose-500 text-white text-sm uppercase tracking-widest hover:from-lavender-600 hover:to-rose-500 transition-all duration-300 rounded-full shadow-lg shadow-lavender-500/30" data-id="element-367">
              Book Now
            </a>
            <a href="tel:+13104903242" className="inline-flex items-center gap-2 text-lg font-bold tracking-widest text-white hover:text-rose-200 transition-colors drop-shadow-[0_1px_8px_rgba(244,114,182,0.5)]" data-id="element-368">
              <Phone size={20} className="text-rose-400" strokeWidth={2.4} data-id="element-369" />
              (310) 490-3242
            </a>
          </div>
        </nav>

        {/* Mobile: always-visible phone + menu button */}
        <div className="flex items-center gap-4 md:hidden" data-id="element-370">
          <a href="tel:+13104903242" aria-label="Call (310) 490-3242" className="inline-flex items-center gap-1.5 text-base font-bold tracking-wide text-white hover:text-rose-200 transition-colors drop-shadow-[0_1px_8px_rgba(244,114,182,0.5)]" data-id="element-371">
            <Phone size={18} className="text-rose-400" strokeWidth={2.4} data-id="element-372" />
            <span className="whitespace-nowrap" data-id="element-373">(310) 490-3242</span>
          </a>
          <button className="text-lavender-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-374">
            {isMobileMenuOpen ? <X size={28} data-id="element-375" /> : <Menu size={28} data-id="element-376" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-377">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-plum-950 border-b border-lavender-400/10 md:hidden" data-id="element-378">
            <div className="flex flex-col px-6 py-8 space-y-6" data-id="element-379">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg uppercase tracking-widest text-lavender-100/80 hover:text-lavender-300" data-id="element-380">
                  {link.name}
                </a>)}
              <a href="#reservations" onClick={() => setIsMobileMenuOpen(false)} className="inline-block text-center px-6 py-3 bg-gradient-to-r from-lavender-500 to-rose-500 text-white text-sm uppercase tracking-widest rounded-full" data-id="element-381">
                Book Now
              </a>
              <a href="tel:+13104903242" onClick={() => setIsMobileMenuOpen(false)} className="inline-flex items-center justify-center gap-2 text-2xl font-bold tracking-widest text-white hover:text-rose-200 transition-colors drop-shadow-[0_1px_8px_rgba(244,114,182,0.5)]" data-id="element-382">
                <Phone size={24} className="text-rose-400" strokeWidth={2.4} data-id="element-383" />
                (310) 490-3242
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}